import { useMutation } from "@tanstack/react-query";
import { createAxiosWithAuth } from "./middleware";

export const useAddToFarm = () => {
  const axios = createAxiosWithAuth();

  return useMutation({
    mutationKey: ["farm-bind"],
    mutationFn: async (query) => {
      return await axios.post("/farm/bind", query);
    },
  });
};
